// [2026-10-08] ADDED — IncScreen feedback report, "Call Events Log": which Activity Log entries the
// report shows. Until now the list lived inside Feedback.tsx and held call events only. Scheduling is
// part of the same story — a candidate who says "call me at 7" on the AI call, or picks a slot on the
// slot page, is saved as "Slot Updated" — so the report showed a call, then another call, with nothing
// between them to say why. "Slot Updated" is now shown as well, and an entry's `detail` line
// (for example "Wed 7 Oct, 6:55–7:55 PM — requested on AI call", or the redial note on
// "Call Connection Failed") is kept so the report can print it under the event.
// Action names are the stored ones (node-engine IncRecruitInterview LogsSchema and
// candidate-listing-system vapiPostCall) — the same words the Activity Log on the candidate screen shows.
export const CALL_EVENT_ACTIONS = new Set<string>([
  "Call Initiated",
  "AI ended the call",
  "Candidate ended the call",
  "Call reached the candidate's voicemail",
  "Candidate's line was busy",
  "Call ended due to prolonged silence",
  "Candidate did not answer the call",
  "Completed",
  "Call Connection Failed",
  // [2026-10-08] ADDED — scheduling: a callback booked on the AI call, or a slot picked on the slot page.
  "Slot Updated",
]);

export interface CallEventLog {
  action: string;
  detail?: string;
  createdAt?: string;
  user?: string;
  [key: string]: any;
}

// The entries to show, in their stored order. Entries are returned as they are; only a blank or
// non-text `detail` is left out, so the report never prints an empty line. Never throws.
export function callEventsForReport(logs: unknown): CallEventLog[] {
  if (!Array.isArray(logs)) return [];
  return logs
    .filter((log: any) => log && typeof log.action === "string" && CALL_EVENT_ACTIONS.has(log.action))
    .map((log: any) => {
      if (log.detail === undefined || (typeof log.detail === "string" && log.detail.trim())) return log;
      const { detail, ...rest } = log;
      return rest;
    });
}
